// import { Box, Divider, IconButton, Stack, Typography } from "@mui/material";
// import React, { useCallback, useEffect, useRef, useState } from "react";
// import {

//   DateCover,
//   MessageInput,
//   ReplyMessage,
//   UserMessage,
// } from "./message-ui";
// import CommentContainer from "../ui-elements/comment-container";
// import { useSelector } from "react-redux";
// import { RootState } from "../../store/store";
// import { useMessaging } from "../../hooks/useMessaging";
// import { ArrowDownward } from "@mui/icons-material";
// import { getDateKey } from "../../utils/date-setup";

// const MessageInformation = () => {
//   const messages = useSelector((state: RootState) => state.message.messages);
//   const hasMoreMessages = useSelector(
//     (state: RootState) => state.message.hasMoreMessages
//   );
//   const currentPage = useSelector(
//     (state: RootState) => state.message.currentPage
//   );
//   const chartHeader = useSelector(
//     (state: RootState) => state.message.chartHeader
//   );
//   const account_profile = useSelector(
//     (state: RootState) => state.content.account_profile_data
//   );
//   const { sendMessage, fetchPaginatedMessages } = useMessaging();

//   const [showScrollButton, setShowScrollButton] = useState(false);
//   const messagesContainerRef = useRef<HTMLDivElement>(null);
//   const lastMessageRef = useRef<HTMLDivElement>(null);
//   // Add a flag to track initial load
//   const [isInitialLoad, setIsInitialLoad] = useState(true);

//   // Separate function for handling different scroll scenarios
//   const handleMessageScroll = useCallback(() => {
//     // Case 1: Initial load or chat selection - scroll to bottom
//     if (isInitialLoad && messages.length > 0) {
//       scrollToBottom();
//       setIsInitialLoad(false);
//       return;
//     }

//     // Case 2: New message from the current user - scroll to bottom
//     const lastMessage = messages[messages.length - 1];
//     if (lastMessage?.sender_id === account_profile.id) {
//       scrollToBottom();
//       return;
//     }

//     // Case 3: New message from other user - only scroll if already near bottom
//     const container = messagesContainerRef.current;
//     if (container) {
//       const isNearBottom =
//         container.scrollHeight - container.scrollTop <=
//         container.clientHeight + 150;
//       if (isNearBottom) {
//         scrollToBottom();
//       }
//     }
//   }, [messages, isInitialLoad, account_profile.id]);

//   // Reset initial load flag when changing chats
//   useEffect(() => {
//     setIsInitialLoad(true);
//   }, [chartHeader.id]);

//   // Handle scrolling whenever messages change
//   useEffect(() => {
//     handleMessageScroll();
//   }, [messages, handleMessageScroll]);

//   const scrollToBottom = () => {
//     // Add a small delay to ensure DOM has updated
//     setTimeout(() => {
//       lastMessageRef.current?.scrollIntoView({
//         behavior: isInitialLoad ? "auto" : "smooth",
//       });
//     }, 0);
//   };

//   const handleScroll = () => {
//     const container = messagesContainerRef.current;
//     if (!container) return;

//     // Show scroll button when not at bottom
//     const isAtBottom =
//       container.scrollHeight - container.scrollTop <=
//       container.clientHeight + 100;
//     setShowScrollButton(!isAtBottom);

//     // Check if we're near the top to load more messages
//     if (container.scrollTop <= 100 && hasMoreMessages) {
//       fetchPaginatedMessages(chartHeader.id, currentPage + 1);
//     }
//   };

// // Component to render messages with date headers
// const MessageList = ({ messages, account_profile }: any) => {
//   // Keep track of the last shown date to avoid repetition
//   let lastShownDate = '';

//   return messages.map((message: any, index: number) => {
//     // Get the current message's date
//     const currentDate = getDateKey(message.sent_at);

//     // Determine if we should show the date header
//     const shouldShowDate = currentDate !== lastShownDate;

//     // Update the last shown date
//     if (shouldShowDate) {
//       lastShownDate = currentDate;
//     }

//     return (
//       <React.Fragment key={message?.id}>
//         {/* Show DateCover only when date changes */}
//         {shouldShowDate && <DateCover date={message.sent_at} />}

//         {/* Message component with ref for scroll handling */}
//         <Box ref={index === messages.length - 1 ? lastMessageRef : null}>
//           {message.sender_id !== account_profile?.id ? (
//             <UserMessage chat={message} message_time={message.sent_at} />
//           ) : (
//             <ReplyMessage chat={message} message_time={message.sent_at} />
//           )}
//         </Box>
//       </React.Fragment>
//     );
//   });
// };

//   return (
//     <Box
//       sx={{
//         backgroundColor: "#FFFFFF",
//         position: "relative",
//         py: 2,
//         px: 4,
//       }}
//     >
//       {/* show brief info on the selected client */}
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "row",
//           width: "75%",
//           gap: 2,
//         }}
//       >
//         <img
//           alt="i"
//           src={chartHeader.photo_url}
//           style={{ width: 30, height: 30, borderRadius: 40 }}
//         />
//         <Stack>
//           <Typography
//             sx={{
//               fontSize: 16,
//               fontWeight: 600,
//               color: "#141414",
//             }}
//           >
//             {chartHeader.name}
//           </Typography>
//         </Stack>
//       </Box>
//       <Divider sx={{ my: 2 }} />
//       <Box
//         ref={messagesContainerRef}
//         onScroll={handleScroll}
//         sx={{ pb: "4rem", height: "65vh", overflowY: "auto" }}
//       >
//            <MessageList
//             messages={messages}
//             account_profile={account_profile}
//             lastMessageRef={lastMessageRef}
//           />
//         {messages?.map((message, index) => (
//           <Box
//             key={message?.id}
//             ref={index === messages.length - 1 ? lastMessageRef : null}
//           >

//             {message.sender_id !== account_profile?.id ? (
//               <UserMessage chat={message} message_time={message.sent_at} />
//             ) : (
//               <ReplyMessage chat={message} message_time={message.sent_at} />
//             )}
//           </Box>
//         ))}
//       </Box>
//       {showScrollButton && (
//         <IconButton
//           onClick={scrollToBottom}
//           sx={{
//             position: "absolute",
//             bottom: 80,
//             right: 20,
//             backgroundColor: "primary.main",
//             color: "white",
//             "&:hover": {
//               backgroundColor: "primary.dark",
//             },
//           }}
//         >
//           <ArrowDownward />
//         </IconButton>
//       )}
//       <MessageInput receiverId={chartHeader.id} sendMessage={sendMessage} />
//     </Box>
//   );
// };

// export default MessageInformation;

import { Box, Divider, IconButton, Stack, Typography } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  DateCover,
  MessageInput,
  ReplyMessage,
  UserMessage,
} from "./message-ui";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useMessaging } from "../../hooks/useMessaging";
import { ArrowDownward } from "@mui/icons-material";
import { getDateKey } from "../../utils/date-setup";
import debounce from "lodash.debounce";
import { setIsLoadingMessages } from "../../store/messageSlice";

const MessageInformation = () => {
  const messages = useSelector((state: RootState) => state.message.messages);
  const dispatch = useDispatch();
  const hasMoreMessages = useSelector(
    (state: RootState) => state.message.hasMoreMessages
  );
  const currentPage = useSelector(
    (state: RootState) => state.message.currentPage
  );
  const chartHeader = useSelector(
    (state: RootState) => state.message.chartHeader
  );
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const isLoadingMessage = useSelector(
    (state: RootState) => state.message.isLoadingMessages
  );
  const { sendMessage, fetchPaginatedMessages } = useMessaging();

  const [showScrollButton, setShowScrollButton] = useState(false);
  const messagesContainerRef = useRef<HTMLDivElement>(null);
  const lastMessageRef = useRef<HTMLDivElement>(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const scrollToBottom = useCallback(() => {
    setTimeout(() => {
      lastMessageRef.current?.scrollIntoView({
        behavior: isInitialLoad ? "auto" : "smooth",
      });
    }, 100); // Ensure any potential DOM updates complete
  }, [isInitialLoad]);

  const handleScroll = useCallback(
    debounce(() => {
      const container = messagesContainerRef.current;
      if (!container) return;

      // Show scroll button when not at the bottom
      const isAtBottom =
        container.scrollHeight - container.scrollTop <=
        container.clientHeight + 100;
      setShowScrollButton(!isAtBottom);

      // Load more messages if near the top
      if (container.scrollTop <= 100 && hasMoreMessages) {
        fetchPaginatedMessages(chartHeader.id, currentPage + 1);
      }
    }, 300),
    [fetchPaginatedMessages, chartHeader.id, currentPage, hasMoreMessages]
  );

  // const handleMessageScroll = useCallback(() => {
  //   const container = messagesContainerRef.current;

  //   // Case 1: Initial load or chat selection
  //   if (isInitialLoad && messages.length > 0) {
  //     scrollToBottom();
  //     setIsInitialLoad(false);
  //     return;
  //   }

  //   // Case 2: New message from the current user
  //   const lastMessage = messages[messages.length - 1];
  //   if (lastMessage?.sender_id === account_profile.id) {
  //     scrollToBottom();
  //     return;
  //   }

  //   // Case 3: New message from another user
  //   if (container) {
  //     const isNearBottom =
  //       container.scrollHeight - container.scrollTop <=
  //       container.clientHeight + 150;
  //     if (isNearBottom) {
  //       scrollToBottom();
  //     }
  //   }
  // }, [messages, isInitialLoad, account_profile.id, scrollToBottom]);

  const handleMessageScroll = useCallback(() => {
    const container = messagesContainerRef.current;

    // Case 3: Preserve scroll position when loading older messages
    if (isLoadingMessage) {
      
      if (container) {
        // Preserve current scroll height before adding messages
        const previousScrollHeight = container.scrollHeight;

        setTimeout(() => {
          // Adjust scroll position after older messages are added
          container.scrollTop = container.scrollHeight - previousScrollHeight;
        }, 50); // Small delay to ensure DOM updates
      }
      
      return;
    }

    // Case 1: Initial load or chat selection
    if (isInitialLoad && messages.length > 0) {
      
      scrollToBottom();
      setIsInitialLoad(false);
      return;
    }

    // Case 2: New message from the current user
    const lastMessage = messages[messages.length - 1];
    if (lastMessage?.sender_id === account_profile.id && !isLoadingMessage) {
      
      scrollToBottom();
      return;
    }

    // Case 4: New message from another user (scroll only if near bottom)
    if (container) {
      const isNearBottom =
        container.scrollHeight - container.scrollTop <=
        container.clientHeight + 150;
      if (isNearBottom) {
        scrollToBottom();
      }
    }
  }, [
    messages,
    isInitialLoad,
    account_profile.id,
    scrollToBottom,
    isLoadingMessage,
  ]);

  useEffect(() => {
    setIsInitialLoad(true); // Reset flag when changing chats
  }, [chartHeader.id]);

  useEffect(() => {
    handleMessageScroll(); // Scroll when messages change
  }, [messages, handleMessageScroll]);

  const MessageList = ({ messages }: any) => {
    let lastShownDate = "";

    return messages.map((message: any, index: number) => {
      const currentDate = getDateKey(message.sent_at);
      const shouldShowDate = currentDate !== lastShownDate;

      if (shouldShowDate) lastShownDate = currentDate;

      return (
        <React.Fragment key={message?.id}>
          {shouldShowDate && <DateCover date={message.sent_at} />}
          <Box ref={index === messages.length - 1 ? lastMessageRef : null}>
            {message.sender_id !== account_profile?.id ? (
              <UserMessage chat={message} message_time={message.sent_at} />
            ) : (
              <ReplyMessage chat={message} message_time={message.sent_at} />
            )}
          </Box>
        </React.Fragment>
      );
    });
  };

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        position: "relative",
        pt: 4,
        px: 4,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
        <img
          alt="i"
          src={chartHeader.photo_url}
          style={{ width: 30, height: 30, borderRadius: 40 }}
        />
        <Stack>
          <Typography sx={{ fontSize: 16, fontWeight: 600, color: "#141414" }}>
            {chartHeader.name}
          </Typography>
        </Stack>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Box
        ref={messagesContainerRef}
        onScroll={handleScroll}
        sx={{ pb: "4rem", height: "65vh", overflowY: "auto" }}
      >
        <MessageList messages={messages} />
      </Box>
      {showScrollButton && (
        <IconButton
          onClick={scrollToBottom}
          sx={{
            position: "absolute",
            bottom: 80,
            right: 20,
            backgroundColor: "primary.main",
            color: "white",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          }}
        >
          <ArrowDownward />
        </IconButton>
      )}
      <MessageInput receiverId={chartHeader.id} sendMessage={sendMessage} />
    </Box>
  );
};

export default MessageInformation;
